var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpwards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 5,
    viewBox: "0 0 32 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 3.81571C0 3.34274 0.336868 2.93684 0.80174 2.84967L14.1571 0.345541C15.3751 0.11717 16.6249 0.11717 17.8429 0.345541L31.1983 2.84967C31.6631 2.93684 32 3.34274 32 3.81571C32 4.43113 31.4409 4.89516 30.836 4.78175L17.4743 2.27643C16.4999 2.09374 15.5001 2.09374 14.5257 2.27643L1.164 4.78175C0.559131 4.89516 0 4.43113 0 3.81571Z",
    fill: "#979CAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpwards);
export default __webpack_public_path__ + "static/media/arrowUpwards.d18493526266f305e05c8d354a8f7d00.svg";
export { ForwardRef as ReactComponent };